import { FirebaseTracker } from '@quipper/k12-frontend-firebase-tracker';
import { initializeAnalytics } from 'firebase/analytics';
import { getApp, getApps, initializeApp } from 'firebase/app';

const hasExistingApp = getApps().length > 0;

export const app = hasExistingApp
  ? getApp()
  : initializeApp({
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_FIREBASE_APP_ID,
      measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
    });

// FirebaseTracker の getAnalytics より先に初期化して GA の Cookie に Secure を付ける（初期化済みの app に呼ぶと例外になる）
if (!hasExistingApp) {
  initializeAnalytics(app, { config: { cookie_flags: 'secure' } });
}

export const tracker = new FirebaseTracker(app);
